const getPriceStripped = (price = ''): string => price.slice(3).trim();

const getCommaPriceFormate = (value: string | undefined): string =>
  value ? value.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';

const displayValueWithSymbolAndDiscount = (value: string): string =>
  parseFloat(value) ? `₹${value} off` : '';
const displayValueWithSymbol = (value: string): string => (parseFloat(value) ? `₹${value}` : '');
const displayValue = (value: number | undefined): string => ((value || value === 0) ? `₹${Math.round(value)}` : '');

const calculateDiscount = (totalValue: number | undefined, value: number | undefined): string =>
  totalValue && value ? `${Math.round(((totalValue - value) / totalValue) * 100)}% OFF` : '';

const formatPrice = (price: string = '') => {
  const priceSplit = price.toString().split('.');
  const rs = priceSplit[0].toLowerCase().match('rs');
  let formattedPrice = rs ? `${priceSplit[1]}`.trim() : `${priceSplit[0]}`.trim();
  formattedPrice = getCommaPriceFormate(formattedPrice);
  return formattedPrice;
};

export default getPriceStripped;
export {
  displayValue,
  calculateDiscount,
  displayValueWithSymbol,
  getCommaPriceFormate,
  formatPrice,
  displayValueWithSymbolAndDiscount
};
